// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ArticleTagList_componentStyle__QG53h","itemBlock":"ArticleTagList_itemBlock__3l_tG"};